import React, { useEffect } from "react";
import LandingNav from "./landing/LandingNav";
import Hero from "./landing/Hero";
import SocialProofStrip from "./landing/SocialProofStrip";
import VideoSection from "./landing/VideoSection";
import FeaturesGrid from "./landing/FeaturesGrid";
import HowItWorks from "./landing/HowItWorks";
import PricingContact from "./landing/PricingContact";
import FaqSection from "./landing/FaqSection";
import FinalCTA from "./landing/FinalCTA";
import Footer from "./landing/Footer";

export default function LandingPage() {
  useEffect(() => {
    document.title = "Cricket Graphics Studio — Broadcast Cricket Like a Pro";
  }, []);

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100">
      <LandingNav />
      <Hero />
      <SocialProofStrip />
      <VideoSection />
      <FeaturesGrid />
      <HowItWorks />
      <PricingContact />
      <FaqSection />
      <FinalCTA />
      <Footer />
    </div>
  );
}
